import _ from 'lodash';
import Model from './model';

export default class User extends Model {

	isAdmin () {
		return _.get(this, 'role.id') === 'SUPER_ADMIN';
	}

	isLoggedIn () {
		return !!this.id;
	}

	/**
	 * Checks if any given permissions are granted.
	 */
	canAny () {

		// Short-circuit the permission check for admins
		if (this.isAdmin()) {
			return true;
		}

		// Return true if any permission is granted
		for (const permission of arguments) {
			if (this.can(permission)) {
				return true;
			}
		}

		return false;
	}

	/**
	 * Checks if all given permissions are granted.
	 */
	canAll () {

		// Short-circuit the permission check for admins
		if (this.isAdmin()) {
			return true;
		}

		// Return false if any permission is denied
		for (const permission of arguments) {
			if (!this.can(permission)) {
				return false;
			}
		}

		return true;
	}

	/**
	 * Checks if a given permission is granted.
	 */
	can (permission) {

		// Short-circuit the permission check for admins
		if (this.isAdmin()) {
			return true;
		}

		const userPermissions = _.get(this, 'role.permissions.names');

		return (Array.isArray(userPermissions) && userPermissions.indexOf(permission) !== -1);
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/models/user.js